var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jobs.length > 0)?_c('router-link',{staticClass:"btn btn-sm btn-success px-3 py-1",attrs:{"to":{name: 'jobs-running'}}},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.jobs.length))]),_vm._v(" RUNNING JOBS")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }